define(
    'utils/is-extension',[],

    function () {
        return function (fileName, exts) {
            return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
        };
    }
);

